import React from 'react';

import { styled } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import { SHADOW } from 'styles/theme';
import { NavigationDirection } from '../types';

type ScrollButtonProps = {
    direction: NavigationDirection;
    handleNavigation: (direction: NavigationDirection) => void;
    onClick?: () => void;
};

const getIcon = (direction: NavigationDirection) =>
    direction === 'left' ? (
        <KeyboardArrowLeftIcon />
    ) : (
        <KeyboardArrowRightIcon />
    );

const StyButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== 'direction',
})<{ direction: NavigationDirection }>(({ direction, theme }) => ({
    backgroundColor: 'white',
    '&:hover': {
        backgroundColor: 'white',
        boxShadow: SHADOW,
    },
    border: `0.5px solid ${theme.palette.primary.background}`,
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    ...(direction === 'left'
        ? { left: '2%', transform: 'translateY(-50%)' }
        : { left: '98%', transform: 'translate(-100%, -50%)' }),
    zIndex: 9,
}));

const ScrollButton = ({
    direction,
    handleNavigation,
    onClick = () => {},
}: ScrollButtonProps): JSX.Element => {
    const handleClick = () => {
        handleNavigation(direction);
        onClick();
    };

    return (
        <StyButton color="primary" direction={direction} onClick={handleClick}>
            {getIcon(direction)}
        </StyButton>
    );
};

export default ScrollButton;
